<template>
  <div class="app">
    <h1>税务服务</h1>
    <Header :activeIndex="'5'"/>


    <!-- 税务服务 -->
    <div class="tiaozhuan"><span style="cursor: pointer;" @click="pathIndex">首页</span><span>&nbsp;&gt;&gt;&nbsp;</span><span>税务服务</span></div>
    <div class="margintop">服务内容</div>
    <div class="juli">
      <table class="tableCSS">
        <thead>
          <tr>
            <th class="thCSS1">序号</th>
            <th class="thCSS">服务内容</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="tdCSS1">1</td>
            <td class="tdCSS">税务股权变更</td>
          </tr>
          <tr>
            <td class="tdCSS1">2</td>
            <td class="tdCSS">给出税收优化方案</td>
          </tr>
          <tr>
            <td class="tdCSS1">3</td>
            <td class="tdCSS">配合税务核查</td>
          </tr>
          <tr>
            <td class="tdCSS1">4</td>
            <td class="tdCSS">税务年报、税务汇算</td>
          </tr>
          <tr>
            <td class="tdCSS1">5</td>
            <td class="tdCSS">打印银行对账单</td>
          </tr>
          <tr>
            <td class="tdCSS1">6</td>
            <td class="tdCSS">申报房产税</td>
          </tr>
          <tr>
            <td class="tdCSS1">7</td>
            <td class="tdCSS">申报残保金</td>
          </tr>
          <tr>
            <td class="tdCSS1">8</td>
            <td class="tdCSS">抄报税控数据</td>
          </tr>
        </tbody>
      </table>
      <table class="tableCSS">
        <thead>
          <tr>
            <th class="thCSS1">序号</th>
            <th class="thCSS">服务内容</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="tdCSS1">9</td>
            <td class="tdCSS">申领空白发票</td>
          </tr>
          <tr>
            <td class="tdCSS1">10</td>
            <td class="tdCSS">发票增版、增量</td>
          </tr>
          <tr>
            <td class="tdCSS1">11</td>
            <td class="tdCSS">发票认证</td>
          </tr>
          <tr>
            <td class="tdCSS1">12</td>
            <td class="tdCSS">代开专用发票</td>
          </tr>
          <tr>
            <td class="tdCSS1">13</td>
            <td class="tdCSS">开具增值税发票</td>
          </tr>
          <tr>
            <td class="tdCSS1">14</td>
            <td class="tdCSS">解除税务异常</td>
          </tr>
          <tr>
            <td class="tdCSS1">15</td>
            <td class="tdCSS">税务迁移、税务汇算</td>
          </tr>
          <tr>
            <td class="tdCSS1">16</td>
            <td class="tdCSS">注销税务</td>
          </tr>
        </tbody>
      </table>
    </div>

    <Youshi />
    <Footer />
  </div>
</template>


<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Youshi from '@/components/Youshi.vue'

export default {
  name: 'shuiwu',
  components: {
    Header,
    Footer,
    Youshi
  },
  data() {
    return {
      activeIndex: '5',
      imgCount: 0,
      currentIndex: 0,
      intervalID: '',
      pppclose: true
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    // console.log(this.$root.showData.showData);
    this.$root.showData.showData = false;
  },
  methods: {
    pppopco() {
      this.$root.ppp.ppp = !this.$root.ppp.ppp
    },
    pathIndex() {
      this.$router.push('/');
    },
    pathRemen() {
      this.$router.push('/remen')
    },
    pathJizhang() {
      this.$router.push('/jizhang')
    },
    pathgongshang() {
      this.$router.push('/gongshang')
    },
    pathzhichan() {
      this.$router.push('/zhichan')
    },
    pathshuiwu() {
      this.$router.push('/shuiwu');
    },
    pathxuke() {
      this.$router.push('/xuke')
    },
    pathrenshi() {
      this.$router.push('/renshi')
    },
    pathxueyuan() {
      this.$router.push('/xueyuan');
    },
    pathabout() {
      this.$router.push('/about')
    },
    pathcontact() {
      this.$router.push('/contact')
    },
  }
}
</script>


<style>
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}

.el-carousel__button {
  background-color: #000 !important;
}

.el-menu-item.is-active {
  background-color: #b30101 !important;
}

.el-menu--horizontal>.el-menu-item {
  float: left;
  height: 45px !important;
  line-height: 45px !important;
  margin: 0;
}

@media (max-width: 768px) {

  .el-menu--horizontal>.el-menu-item {
    float: left;
    height: 30px !important;
    line-height: 30px !important;
    margin: 0;
  }

  .responsive-carousel el-carousel el-carousel--horizontal {
    height: 128px !important;
  }

  .el-carousel__indicators el-carousel__indicators--horizontal {
    margin-top: 15px !important
  }

  .el-pager li {
    padding: 0 0px !important;
    min-width: 25.5px !important;
  }
}
</style>

<style scoped>
/* 服务内容 */
.juli {
  margin-left: 20%;
  margin-right: 20%;
  display: flex;
  gap: 20px;
}

.tableCSS {
  width: 90%;
  border-collapse: collapse;
  margin: 0 auto;
}

.tdCSS1 {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
  font-weight: bold;
  font-style: italic;
  color: #d22525;
}

.tdCSS {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.thCSS1 {
  background-color: #f2f2f2;
  padding: 8px;
  text-align: center;
  border: 1px solid #ddd;
  width: 50px;
}

.thCSS {
  background-color: #f2f2f2;
  padding: 8px;
  text-align: center;
  border: 1px solid #ddd;
}

/* 其他 */
ul,
li {
  margin: 0;
  padding: 0;

}

h1 {
  font-size: 0%;
}

.margintop {
  margin-left: auto;
  margin-right: auto;
  font-size: 25px;
  margin-bottom: 11px;
  font-weight: 700;
  font-family:Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  /* font-family: 'msyh', sans-serif; */
}

.tiaozhuan {
  text-align: left;
  margin-bottom: 0.83em;
  margin-top: 118px;
  margin-left: 19.5%;
  font-size:18px;
  font-weight: 500;
}


@media (max-width: 768px) {
  /* 服务内容 */
  .juli {
    margin-left: 3%;
    margin-right: 3%;
    display: flex;
    gap: 10px;
  }

  .tableCSS {
    width: 90%;
    border-collapse: collapse;
    margin: 0 auto;
    font-size: 13px;
  }

  .tdCSS1 {
    border: 1px solid #ddd;
    padding: 1px;
    text-align: center;
    font-weight: bold;
    font-style: italic;
    color: #d22525;
    height: 25px;
  }

  .tdCSS {
    border: 1px solid #ddd;
    padding: 1px;
    text-align: left;
  }

  .thCSS1 {
    background-color: #f2f2f2;
    padding: 1px;
    text-align: center;
    border: 1px solid #ddd;
    width: 30px;
    height: 25px;
  }

  .thCSS {
    background-color: #f2f2f2;
    padding-left: 1px;
    padding-right: 1px;
    text-align: center;
    border: 1px solid #ddd;
  }


  /* 其他 */
  .margintop {
    margin-left: auto;
    margin-right: auto;
    font-size: 15px;
    margin-bottom: 5px;
  }

  .tiaozhuan {
    text-align: left;
    margin-bottom: 0.83em;
    margin-top: 100px;
    margin-left: 2%;
    font-size:11px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/shuiwu.vue